export const TopMenuConfig = {
  RecipientsFilters: {
    ProfileFilters: {
      NavMenuId: 'ProfileFilters',
      LabelLangId: 'Load.NavMenu.ProfileFilters',
      HelpId: 'Filtri_Profilo_Elenco',
      route: '/filter/profile',
      visibilityCondition:
        '(uo:FILTER AND co:FILTER) OR (NOT c:IsSendMethodFrequency AND NOT co:FILTER)',
      dataTest: 'topmenu-item__list__profile',
    },
    ActivityFilters: {
      NavMenuId: 'ActivityFilters',
      LabelLangId: 'Load.NavMenu.ActivityFilters',
      HelpId: 'Filtri_Attivita_Elenco',
      route: '/filter/activity',
      visibilityCondition:
        '((uo:FILTER AND co:FILTER) OR (NOT c:IsSendMethodFrequency AND NOT co:FILTER)) AND uo:NL',

      dataTest: 'topmenu-item__list__activity',
    },
    EngagementFilters: {
      NavMenuId: 'EngagementFilters',
      LabelLangId: 'Load.NavMenu.EngagementFilters',
      HelpId: '',
      route: '/filter/engagement',
      visibilityCondition: 'uo:FILTER AND co:FILTER',
      dataTest: 'topmenu-item__list__engagement',
    },
    GeolocationFilters: {
      NavMenuId: 'GeolocationFilters',
      LabelLangId: 'Load.NavMenu.GeolocationFilters',
      HelpId: 'Filtri_Geo_Elenco',
      route: '/filter/geolocation',
      visibilityCondition:
        '((uo:FILTER AND co:FILTER) OR (NOT c:IsSendMethodFrequency AND NOT co:FILTER)) AND uo:NL',
      dataTest: 'topmenu-item__list__geolocation',
    },
    DeviceFilters: {
      NavMenuId: 'DeviceFilters',
      LabelLangId: 'Load.NavMenu.DeviceFilters',
      HelpId: 'FormElencoFiltriDevice',
      route: '/filter/device',
      visibilityCondition:
        '((uo:FILTER AND co:FILTER) OR (NOT c:IsSendMethodFrequency AND NOT co:FILTER))',
      dataTest: 'topmenu-item__list__device',
    },
    FiltersCategories: {
      NavMenuId: 'FiltersCategories',
      LabelLangId: 'Load.NavMenu.FiltersCategories',
      HelpId: 'FiltroCategoriaList',
      route: '/categories',
      visibilityCondition: 'uo:FILTER',
      dataTest: 'topmenu-item__list__categories',
    },
  },
  FiltersList: {
    EngagementFilters: {
      NavMenuId: 'FiltersList',
      LabelLangId: 'Load.NavMenu.FiltersList',
      HelpId: '',
      route: '/filters/list',
      visibilityCondition: 'uo:FILTER AND co:FILTER',
      dataTest: 'topmenu-item__list__filters',
    },
    FiltersCategories: {
      NavMenuId: 'FiltersCategories',
      LabelLangId: 'Load.NavMenu.FiltersCategories',
      HelpId: 'FiltroCategoriaList',
      route: '/categories',
      visibilityCondition: 'uo:FILTER',
      dataTest: 'topmenu-item__list__categories',
    },
  },
}
